


















import Vue from 'vue'
import Component from 'vue-class-component'
import {State} from "vuex-class";
import {Machine} from "@/modules/unigest";
import {Prop} from "vue-property-decorator";

/**
 * Selector de maquinas
 */
@Component
export default class MachineSelect extends Vue {
    @State
    public machines: Machine[]

    /**
     * Maquina seleccionad actualmente por el usuario
     */
    @Prop({type: Machine, default: null})
    public value: Machine | null

    public get currentMachineIndex () {
        if (!this.value) {
            return null
        }

        return this.machines.findIndex(machine => machine.name === this.value?.name)
    }

    async created () {
        await this.$store.dispatch('loadMachines')
    }
}

